import { styled } from '@linaria/react'
import { ButtonSC } from 'atoms/Button'
import {
  InlinePlaySolidButton,
  PrimaryInfoButton,
} from 'atoms/Button/Templates'
import { IconSC, IconSizes } from 'atoms/Icon'
import { PosterSC } from 'atoms/ImagePoster'
import { LabelStyled } from 'atoms/Label'
import { OverlayLayoutStyled } from 'atoms/OverlayLayout'
import { Track } from 'atoms/ProgressBar'
import {
  BaseCardSC,
  Card,
  ImageBackgroundSC,
  PosterContainerSC,
} from 'blocks/Cards'
import { Wrapper } from 'blocks/TextBlock'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { TRANSITIONS } from 'vars/index'
import { MEDIA } from 'vars/media'
import { LockedPosterSC } from '../base-card/BaseCard.styled'

export const ContentLabelSC = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;

  ${LabelStyled} {
    position: absolute;
    right: var(${FIXED_INDENTS.INDENT_30});
    bottom: var(${FIXED_INDENTS.INDENT_30});
  }

  ${Track} {
    position: absolute;
    left: 0;
    bottom: 0;
  }
`
export const PrimaryInfoButtonSC = styled(PrimaryInfoButton)``
export const InlinePlaySolidButtonSC = styled(InlinePlaySolidButton)``

export const CardChild = styled.div`
  width: 100%;
  height: 100%;
`

export const CardContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  padding: var(${FIXED_INDENTS.INDENT_30});

  ${InlinePlaySolidButtonSC} {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
  }
`
export const CardStyled = styled.div<{
  width?: string
  height?: string
}>`
  overflow: visible;
  cursor: default;
  width: ${({ width }) => (width ? `${width}` : '100%')};
  height: ${({ height }) => (height ? `${height}` : '100%')};

  ${BaseCardSC} {
    &.scale-up-110 {
      font-size: 1em;
    }

    &.scale-up-110-entered {
      svg {
        transform: scale(0.9);
        transition: transform 0.2s ease;
      }
    }

    &.scale-up-110-exiting {
      svg {
        transform: scale(0.9);
      }
    }

    &.scale-up-110-exited {
      svg {
        transform: scale(1);
        transition: transform var(${TRANSITIONS.LINEAR_400});
      }
    }
  }
`

export const CardInnerStyled = styled(Card)`
  height: ${({ aspectRatio }) =>
    `calc(var(--special-card-width) / ${aspectRatio})`};
  /* Rewrite base card styles to prevent card cutting */
  flex: auto;
`

export const CardStyledContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: var(${FIXED_INDENTS.INDENT_30});
  /* Make fluid margins */

  & > ${Wrapper} {
    gap: initial;

    & > :nth-child(1) {
      margin-bottom: var(${FIXED_INDENTS.INDENT_10});
    }
  }

  ${CardContent} {
    ${ButtonSC} {
      transition: opacity 150ms;

      ${MEDIA.TOUCH} {
        &:nth-child(2) {
          opacity: 0;
        }
      }
    }
  }

  ${BaseCardSC} {
    border-radius: var(${FIXED_INDENTS.INDENT_10});

    ${PosterContainerSC} {
      ${ImageBackgroundSC} {
        ${PosterSC} {
          object-fit: cover;
        }

        ${LockedPosterSC} {
          ${IconSC} {
            font-size: ${IconSizes.xxmLarge};
          }
        }
      }
    }

    ${OverlayLayoutStyled} {
      z-index: 1;
    }
  }

  &:hover {
    ${CardContent} {
      ${ButtonSC} {
        ${MEDIA.NO_TOUCH} {
          opacity: 1;
        }
      }
    }
  }
`
